export const extractPreviewBodyHtml = (iframe) => {
  const doc = iframe?.contentDocument;
  if (!doc?.body) return "";
  return doc.body.innerHTML;
};

export const enableEditableMailPreview = (iframe, onHtmlChange) => {
  const doc = iframe?.contentDocument;
  if (!doc?.body) return undefined;

  doc.body.contentEditable = "true";
  doc.body.style.outline = "none";
  doc.body.style.minHeight = "480px";
  doc.body.style.cursor = "text";

  const handleInput = () => {
    if (typeof onHtmlChange === "function") {
      onHtmlChange(extractPreviewBodyHtml(iframe));
    }
  };

  const handleSelection = () => {
    const selection = doc.getSelection();
    if (!selection?.rangeCount) return;
    iframe.__mailPreviewRange = selection.getRangeAt(0).cloneRange();
  };

  doc.body.addEventListener("input", handleInput);
  doc.addEventListener("keyup", handleInput);
  doc.addEventListener("mouseup", handleSelection);
  doc.addEventListener("keyup", handleSelection);
  doc.addEventListener("selectionchange", handleSelection);
  return () => {
    doc.body.removeEventListener("input", handleInput);
    doc.removeEventListener("keyup", handleInput);
    doc.removeEventListener("mouseup", handleSelection);
    doc.removeEventListener("keyup", handleSelection);
    doc.removeEventListener("selectionchange", handleSelection);
  };
};
